
// Base.
import { Prop, Mixins } from 'vue-property-decorator'
import Component from 'vue-class-component'
import usersMixins from './UsersMixin'

// Used Models.
import { User } from '../../models/user'

import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'

@Component({
  components: {
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class ResetSinglePassword extends Mixins(usersMixins) {
  @Prop(Function) public readonly resetPassword!: (data: User[]) => User[]
  @Prop() private readonly user!: User[]
  @Prop() private buttonActivation: boolean

  constructor() {
    super()
  }

  public mounted() {
    this.initialize()
  }

  private async save() {
    this.isPending = true
    this.resetPassword(this.user)
    this.isPending = false
    this.dialog = false
  }

  private initialize() {
    // TODO
  }
}
